export const Storage = {
    getItem: (key: string): any => JSON.parse(localStorage.getItem(key) || "null"),
    setItem: (key: string, value: any): void =>
        localStorage.setItem(key, JSON.stringify(value !== undefined ? value : null)),
    removeItem: (key: string): void => localStorage.removeItem(key),
    clear: (): void => localStorage.clear(),
};
